module.exports = __webpack_public_path__ + "static/media/help_info.252691df.svg";